'use strict';
import pickBy from 'lodash/pickBy';
import {getAsString, getId} from '../../core-utilities/domain/ReduxUtils';
import {NoteState} from '../../system/enums/NoteState';
import {getProject} from '../../app/model/reducers/state';


ProjectImportExportService.$inject = [
  '$ngRedux',
  '$popup',
  '$download',
  '$toast',
  '$locale',
  '$translate',
  'AuthService',
  'NotificationService',
  'fetchUtils',
];

export function ProjectImportExportService(
  $ngRedux,
  $popup,
  $download,
  $toast,
  $locale,
  $translate,
  AuthService,
  NotificationService,
  fetchUtils,
) {
  this.openProjectAssetsExport = openProjectAssetsExport;
  this.exportProjectAssets = exportProjectAssets;

  const HEADERS = this.HEADERS = {
    milestone_name: {type: 'string'},
    milestone_name_update: {type: 'string', excludeFromDownload: true},
    milestone_name_delete: {type: 'string', excludeFromDownload: true},
    milestone_description: {type: 'string'},
    task_name: {type: 'string'},
    task_name_update: {type: 'string', excludeFromDownload: true},
    task_name_delete: {type: 'string', excludeFromDownload: true},
    task_description: {type: 'string'},
    task_scheduled: {type: 'date'},
    task_use_time: {type: 'boolean'},
    task_duration: {type: 'number', min: 0, max: 20160},
    task_duration_unit: {type: 'string'}, // Validation is currently too complicated to handle on client , inList: ['minutes', 'hours', 'days', 'weeks'], validateUnits}, // , 'months', 'years'
    task_assignment: {type: 'string', excluded: true},
    task_scheduled_comment: {type: 'string'},
    task_status: {type: 'string', excluded: true},
    requirement_name: {type: 'string'},
    requirement_name_update: {type: 'string', excludeFromDownload: true},
    requirement_name_delete: {type: 'string', excludeFromDownload: true},
    requirement_description: {type: 'string'},
    requirement_type: {type: 'string'},
    requirement_status: {type: 'string', excluded: true},
    file_requirement_max: {type: 'number'},
    file_requirement_min: {type: 'number'},
    file_requirement_enforced: {type: 'boolean'},
  };

  this.getExportHeaders = function () {
    return pickBy(HEADERS, header => !header.excludeFromDownload);
  };

  let openProjectAssetsExportCalled = false;

  function openProjectAssetsExport() {
    if (openProjectAssetsExportCalled) return;
    openProjectAssetsExportCalled = true;

    const rootState = $ngRedux.getState();
    const project = getProject(rootState);

    if (project) {
      return $popup
        .confirm({
          title: $translate.instant('projects.export.assets.header.label'),
          /* eslint-disable-next-line max-len */
          template: '<div style="text-align: center;">' + $translate.instant('projects.export.assets.message') + '</div>',
        })
        .then(__exportProjectAssets)
        .finally(__openProjectAssetsExportFinally);
    } else {
      openProjectAssetsExportCalled = false;
    }
  }

  function __openProjectAssetsExportFinally(it) {
    openProjectAssetsExportCalled = false;
    return it;
  }

  function __exportProjectAssets(confirm) {
    if (!confirm) return Promise.resolve(null);
    const rootState = $ngRedux.getState();
    const project = getProject(rootState);
    return exportProjectAssets({
      id: getId(project),
      name: getAsString(project),
    });
  }

  function exportProjectAssets(targetData) {
    const request = {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
    };

    const params = new URLSearchParams({
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      dateFormat: $locale.DATETIME_FORMATS.shortDate,
    });

    const url = `${fetchUtils.API_URL}/api/projects/${targetData.id}/assets/_export?${params.toString()}`;
    const requestPromise = fetchUtils.rawRequestWithAuth(url, request);

    // TODO(i18n)
    NotificationService.addNotification({
      name: `Export all ${targetData.name} data`,
      removal: NotificationService.REMOVAL.ALWAYS, // change this if/when we add a retry save download button/behavior to the notification item
      promise: requestPromise,
      audio: {
        [NoteState.COMPLETE]: true,
        [NoteState.ERROR]: true,
      },
      toasts: {
        [NoteState.ERROR]: true,
      },
    });

    return requestPromise.then(_generateOnExportProjectAssetsSuccess(targetData.name), _onExportProjectAssetsError);
  }

  function _generateOnExportProjectAssetsSuccess(projectName) {
    /**
     * @param {Response} response
     */
    return function _onSuccess(response) {

      // prompt download of csv file containing data
      // console.log('success!', response);

      if (response.status === 204) {
        return $toast.showI18nMessage({messageId: response.messageId, type: $toast.TOAST_TYPES.info});

      } else if (response.status === 200) {
        const body = response.data;
        try {
          if (typeof body.file === 'string') {
            const downloadName = `${projectName.replace(/ /g, '_')}_Assets_Snapshot.csv`;
            return $download.downloadAsTextFile(body.file, downloadName);
          } else {
            return $toast.showI18nMessage({messageId: body.messageId, type: $toast.TOAST_TYPES.info});
          }
        } catch (e) {
          return _onExportProjectAssetsError(e);
        }
      }

      return Promise.resolve(null);
    };
  }

  function _onExportProjectAssetsError(error) {
    // console.warn('errors occurred');
    // console.error(error);
    $toast.showI18nMessage({
      messageId: 'projects.export.failure.message',
      type: $toast.TOAST_TYPES.error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/services/ProjectImportExportService.js